import React from 'react';
import '../../Styles/Legal/termsStyle.css';

function PrivacyPolicy() {
  return (
    <div className="terms-container">
      <header className="terms-header">
        <h1>BIG CIRCLE AUCTIONS LLC<br />PRIVACY POLICY</h1>
      </header>

      <section className="terms-content">
        <p><strong>Effective Date: July 10, 2025</strong></p>

        <p>
          Big Circle Auctions LLC (“BCA”, “we”, “us”, or “our”) is committed to protecting and respecting your privacy.
          This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our
          auction platform (the “Platform”).
        </p>

        <h3>1. INFORMATION WE COLLECT</h3>
        <p>
          1.1 We collect information you provide directly when you register an account, participate in auctions, or
          contact us. This may include your name, email address, postal address, zip code, phone number, payment
          details, and any other information you choose to provide.
        </p>
        <p>
          1.2 We also collect information automatically when you use the Platform, such as IP addresses, browser type,
          device information, browsing activity, and usage data, through cookies and similar technologies.
        </p>

        <h3>2. USE OF YOUR INFORMATION</h3>
        <ul>
          <li>Provide and maintain the Platform.</li>
          <li>Process your registrations and transactions.</li>
          <li>Communicate with you about your account and auction events.</li>
          <li>Send you marketing and promotional materials (where you have consented).</li>
          <li>Ensure security, prevent fraud, and comply with legal obligations.</li>
          <li>Improve and personalize our services and user experience.</li>
        </ul>

        <h3>3. SHARING YOUR INFORMATION</h3>
        <p>3.1 We do not sell or rent your personal data to third parties.</p>
        <p>
          3.2 We may share your information with trusted third-party service providers who assist us in operating the
          Platform, conducting business, or servicing you, provided they agree to keep your data confidential.
        </p>
        <p>
          3.3 We may disclose your information where required by law, regulation, or legal process, or to protect our
          rights or safety or that of others.
        </p>

        <h3>4. COOKIES AND TRACKING TECHNOLOGIES</h3>
        <p>
          4.1 We use cookies and similar tracking technologies to collect information about your use of the Platform,
          to enhance functionality, analyze trends, and improve your experience.
        </p>
        <p>
          4.2 You can set your browser to refuse cookies or alert you when cookies are being sent; however, some
          features of the Platform may not function properly if cookies are disabled.
        </p>

        <h3>5. DATA SECURITY</h3>
        <p>
          5.1 We implement commercially reasonable technical and organizational measures to protect your personal data
          against unauthorized access, disclosure, alteration, or destruction.
        </p>
        <p>
          5.2 Despite these measures, no method of transmission over the internet or electronic storage is 100% secure,
          and we cannot guarantee absolute security.
        </p>

        <h3>6. DATA RETENTION</h3>
        <p>
          6.1 We retain your personal information only for as long as necessary to fulfil the purposes outlined in this
          Privacy Policy, comply with legal obligations, resolve disputes, and enforce agreements.
        </p>

        <h3>7. YOUR RIGHTS</h3>
        <ul>
          <li>Accessing your personal data.</li>
          <li>Requesting correction or deletion of inaccurate data.</li>
          <li>Objecting to or restricting processing.</li>
          <li>Withdrawing consent where applicable.</li>
          <li>Data portability.</li>
          <li>Filing a complaint with a supervisory authority.</li>
        </ul>
        <p>To exercise these rights, contact: <a href="mailto:contact@bigcircleauctions.com">contact@bigcircleauctions.com</a></p>

        <h3>8. INTERNATIONAL TRANSFERS</h3>
        <p>
          8.1 Your information may be processed and stored in the United States or other countries where we or our
          service providers maintain facilities.
        </p>

        <h3>9. CHILDREN'S PRIVACY</h3>
        <p>
          9.1 The Platform is not intended for use by children under 18 years old. We do not knowingly collect personal
          information from children under 18.
        </p>

        <h3>10. CHANGES TO THIS PRIVACY POLICY</h3>
        <p>
          10.1 We may update this Privacy Policy from time to time by posting the new policy and updating the Effective
          Date.
        </p>

        <h3>11. PRIVACY POLICY FOR SMS COMMUNICATIONS</h3>
        <p><strong>Effective Date: July 10, 2025</strong></p>

        <h4>11.1 Information We Collect</h4>
        <ul>
          <li>Your mobile phone number.</li>
          <li>Your name.</li>
          <li>Your physical address.</li>
          <li>Your email address.</li>
          <li>Any preferences or information you voluntarily provide.</li>
        </ul>

        <h4>11.2 How We Use Your Information</h4>
        <ul>
          <li>Send SMS updates, alerts, and promotions.</li>
          <li>Provide reminders and account notifications.</li>
          <li>Improve communications based on feedback.</li>
        </ul>
        <p>We do not sell or share mobile opt-in consent data.</p>

        <h4>11.3 Sharing</h4>
        <p>SMS consent is not shared with third parties. Providers only deliver messages on our behalf.</p>

        <h4>11.4 Opt-Out</h4>
        <p>Reply <strong>STOP</strong> to opt out. Reply <strong>HELP</strong> for assistance. Message & data rates may apply.</p>

        <h3>12. CONTACT</h3>
        <p>
          <strong>Big Circle Auctions LLC</strong><br />
          Email: <a href="mailto:contact@bigcircleauctions.com">contact@bigcircleauctions.com</a><br />
          Address: 414 S Main Street #201, Rochester, MI 48307
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
